import { TextBig } from '../../OrdersTable/index.styled'
import MainIcon from '../../../../../img/svg/main'
import Currency from '../../../currency'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import TableTdElementsTooltip from '../TableTdElementsTooltip'
import { DriverPaymentContent, DriverPaymentText, OrderUnpaidContent, OrderUnpaidText, OrderUnpaidWrapper } from './index.styled'
import { TableTdGrid } from '../../style/table/td/index.styled'
import { selectDriverPaymentsEnabled } from '../../../../../redux/selector/payment'

const OrderPayment = React.memo(({ item, className }) => {
	const { t } = useTranslation()
	const driverPaymentsEnabled = useSelector(selectDriverPaymentsEnabled)
	const isAborted = item?.status?.status === 'ABORTED'
	const isDelivery = item?.orderType === 'DELIVERY'
	const layout = className ? className : ''

	return (
		item.payments.map((payment, i) => {
			const isDriverPayment = driverPaymentsEnabled && isDelivery && payment.deferred && !isAborted

			if (isDriverPayment) {
				const paidClass = payment.payed ? 'paid' : ''
				return (
					<OrderUnpaidWrapper key={i}>
						<DriverPaymentContent>
							<MainIcon icon={payment.method} />
							<TextBig className={(paidClass + ' ' + layout).trim()}><Currency>{payment.total}</Currency></TextBig>
						</DriverPaymentContent>
						<DriverPaymentText className={('small ' + paidClass).trim()}>
							{t(payment.payed ? 'order.table.driver_paid' : 'order.table.driver_payment_pending')}
						</DriverPaymentText>
					</OrderUnpaidWrapper>
				)
			}

			const paymentContent = (!payment.payed && !isAborted) ?
				<OrderUnpaidWrapper key={i}>
					<OrderUnpaidContent>
						<MainIcon className="unpaid" icon={payment.method} />
						<TextBig className={'unpaid ' + layout}><Currency>{payment.total}</Currency></TextBig>
					</OrderUnpaidContent>
					<OrderUnpaidText className="small unpaid">{t('Modal.unpaid_order')}</OrderUnpaidText>
				</OrderUnpaidWrapper> :
				<TableTdGrid key={i}>
					{!isAborted && <TableTdElementsTooltip text={payment?.paymentName ? payment.paymentName : t(`Filter.payment.${payment.method}`)}>
						<MainIcon icon={payment?.paymentName ? 'other-payment' : payment.method} />
					</TableTdElementsTooltip>}
					<TextBig className={layout}><Currency>{payment.total}</Currency></TextBig>
				</TableTdGrid>

			return paymentContent
		})
	)
})

OrderPayment.displayName = 'OrderPayment'
export default OrderPayment
